import p from "./objectWithoutPropertiesLoose.mjs";
import o from "./extends.mjs";
import "react";
import e from "./index180.mjs";
import l from "./styled.mjs";
import { jsx as n } from "react/jsx-runtime";
var r;
const u = ["children", "classes", "className", "label", "notched"], b = l("fieldset")({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
}), g = l("legend")(({
  ownerState: t,
  theme: i
}) => o({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden"
}, !t.withLabel && {
  padding: 0,
  lineHeight: "11px",
  // sync with `height` in `legend` styles
  transition: i.transitions.create("width", {
    duration: 150,
    easing: i.transitions.easing.easeOut
  })
}, t.withLabel && o({
  display: "block",
  // Fix conflict with normalize.css and sanitize.css
  padding: 0,
  height: 11,
  // sync with `lineHeight` in `legend` styles
  fontSize: "0.75em",
  visibility: "hidden",
  maxWidth: 0.01,
  transition: i.transitions.create("max-width", {
    duration: 50,
    easing: i.transitions.easing.easeOut
  }),
  whiteSpace: "nowrap",
  "& > span": {
    paddingLeft: 5,
    paddingRight: 5,
    display: "inline-block",
    opacity: 0,
    visibility: "visible"
  }
}, t.notched && {
  maxWidth: "100%",
  transition: i.transitions.create("max-width", {
    duration: 100,
    easing: i.transitions.easing.easeOut,
    delay: 50
  })
})));
function m(t) {
  const {
    className: i,
    label: a,
    notched: c
  } = t, h = p(t, u), s = a != null && a !== "", d = o({}, t, {
    notched: c,
    withLabel: s
  });
  return /* @__PURE__ */ n(b, o({
    "aria-hidden": !0,
    className: i,
    ownerState: d
  }, h, {
    children: /* @__PURE__ */ n(g, {
      ownerState: d,
      children: s ? /* @__PURE__ */ n("span", {
        children: a
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        r || (r = /* @__PURE__ */ n("span", {
          className: "notranslate",
          children: "​"
        }))
      )
    })
  }));
}
process.env.NODE_ENV !== "production" && (m.propTypes = {
  /**
   * The content of the component.
   */
  children: e.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: e.object,
  /**
   * @ignore
   */
  className: e.string,
  /**
   * The label.
   */
  label: e.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: e.bool.isRequired,
  /**
   * @ignore
   */
  style: e.object
});
export {
  m as default
};
//# sourceMappingURL=NotchedOutline.mjs.map
